module.exports = __webpack_public_path__ + "static/registry2-24e4dd4f2dec46c6d3b887bf0181a270.gif";